import { apiClient } from "../clientApi";
import { useMutation } from "@tanstack/react-query";
import type { DefaultError } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

export interface PostSurveyRequest {
  id: number;
}

export const useDeleteSurvey = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: (data: any, variables: PostSurveyRequest, context: any) => void;
  onFail?: (error: any, variables: PostSurveyRequest, context: any) => void;
}) =>
  useMutation<any, DefaultError, any>({
    mutationFn: async (form) => {
      const { data } = await apiClient.delete<any, AxiosResponse<any>, PostSurveyRequest>(
        `/surveys/survey/${form?.id}`
      );

      return data as any;
    },
    onSuccess,
    onError: onFail,
  });
